import * as React from "react";
require("./styles.css");
const DynamicInput = ({ addButtonText = "Add Input", setInput, input = [], submitButtonText = "Submit", onSubmit, inputName, addPosition = "top", type = "text", placeholderText = "Input..", placeholderNumbered = false, removeText = "Remove", toolTip = false, toolTipText, label = "" }) => {
    const addInput = () => {
        setInput([...input, { [inputName]: "" }]);
    };
    const removeInput = (index) => {
        if (input.length > 1) {
            const items = input.filter((item, subIndex) => index !== subIndex);
            setInput(items);
        }
    };
    const inputChange = (index) => (e) => {
        const elements = input.map((element, subIndex) => {
            if (index !== subIndex) {
                return element;
            }
            else {
                return Object.assign({}, element, { [inputName]: e.target.value });
            }
        });
        setInput(elements);
    };
    return (React.createElement("div", { id: "DynamicInput" },
        label ? React.createElement("h4", { className: "dynamicLabel" }, label) : null,
        addPosition === "top" ? (React.createElement("div", null, toolTip ? (React.createElement("div", { className: "dynamicTooltip" },
            React.createElement("span", { className: "dynamicTooltipText" }, toolTipText),
            React.createElement("button", { className: "addButton", onClick: () => addInput() }, addButtonText))) : (React.createElement("button", { className: "addButton", onClick: () => addInput() }, addButtonText)))) : null,
        input.map((item, index) => (React.createElement("div", { key: (index + 1) * 2 },
            React.createElement("input", { className: "dynamicInput", type: type, placeholder: placeholderNumbered
                    ? `${placeholderText} ${index + 1}`
                    : placeholderText, onChange: inputChange(index), value: item[inputName] }),
            React.createElement("button", { className: "removeButton", onClick: () => removeInput(index) }, removeText)))),
        onSubmit ? (React.createElement("button", { className: "submitButton", onClick: () => onSubmit() }, submitButtonText)) : null,
        addPosition === "bottom" ? (React.createElement("div", null, toolTip ? (React.createElement("div", { className: "dynamicTooltip" },
            React.createElement("span", { className: "dynamicTooltipText" }, toolTipText),
            React.createElement("button", { className: "addButton", onClick: () => addInput() }, addButtonText))) : (React.createElement("button", { className: "addButton", onClick: () => addInput() }, addButtonText)))) : null));
};
export default DynamicInput;
//# sourceMappingURL=DynamicInput.js.map